import React, { useState, useEffect, useMemo } from "react";
import Tablestyles from "../ROCITable.module.css";
import "./templateview.scss";
import TableContainer from "@material-ui/core/TableContainer";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { exportToExcel } from "../../../utils/exportToExcel";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import classNames from "classnames";
import TablePagination from "@material-ui/core/TablePagination";
import SearchBar from "../../../components/Searchbar/searchbar";
import CustomSelect from "../../../components/input/select";
import MultiFilter from "../../../components/Dialog/MultiFilter";
import Loader from "../../../components/Loader/Loader";
import ColumnFilter from "../../../components/Dialog/ColumnFilter";
import * as XLSX from "@lokalise/xlsx";
import Tooltip from "@mui/material/Tooltip";
import { hasDangerousCode } from "../../../utils/utils";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "30px", // minimum width
    maxWidth: "250px", // maximum width
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "30px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

let api = config.api.api_url;

const Input = ({
  name,
  error,
  validation,
  rowHasError,
  errorMessage,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          style={{
            width: "100%",
            backgroundColor: "#fff",
          }}
          rows={2}
          name={name}
          value={value || ""}
          disabled={props.readonly}
          onChange={handleOnChange}
        />
      </div>
    </>
  );
};

const EditableRow = ({
  keys,
  fieldsArr = [],
  editData = {},
  allRowsData,
  customStyles,
  tableName,
  updateSourceInputs,
  sourceData,
  wholeRowData,
  brand_data,
  classes = {},
  editingIndex,
  isEditing,
  selectClasses,
  handleDeleteRow,
  inputClasses,
  updateAlert,
  ...props
}) => {
  const [rowHasError, setRowHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [rowData, setRowData] = useState(editData);
  const [actualData, setActualData] = useState();
  const [updatedData, setUpdatedRowData] = useState();
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [derivedOptions, setDerivedOptions] = useState({});
  const DROPDOWN_DATA = sourceData?.data?.dropdown || {};
  const Edit_Column_Module = DROPDOWN_DATA?.edit_model_column_list || [];

  // const Is_All_Value_Not_Null = useMemo(() => {
  //   return Edit_Column_Module.every((item) => {
  //     const options = dropdownOptions[item.name] || [];
  //     if (options.length === 0) return true;
  //     return editData[item.name] !== null;
  //   });
  // }, [editData, sourceData, dropdownOptions]);

  const Is_New_Data_Null = useMemo(() => {
    return sourceData?.data?.dropdown?.duplicate_validation_attributes
      ? sourceData.data.dropdown.duplicate_validation_attributes.every(
          (item) => {
            return editData[item] !== null;
          },
        )
      : false;
  }, [editData, rowData]);

  const isDerivedColumnValue = (val) => {
    const DerivedValues = sourceData?.data?.dropdown?.TARGET_COLUMN_NAME?.find(
      (item) => item.TARGET_TABLE === val,
    );

    const derivedMap = DerivedValues?.derived_target_column_name;
    setDerivedOptions(derivedMap);
  };

  const handleDropdownOptions = (key, value, itemName) => {
    const dropdownData = sourceData?.data?.dropdown;
    const table_header_column_list = dropdownData?.table_header_column_list;
    const editModelList = dropdownData?.edit_model_column_list;

    if (
      !Array.isArray(table_header_column_list) ||
      !Array.isArray(editModelList)
    ) {
      console.warn("Dropdown data is missing or not in expected format");
      return;
    }

    // STEP 1 = CHECKS ALL VALUES IN ROWDATA ARE NULL
    let Is_All_Value_In_Row_Null = Edit_Column_Module.every((item) => {
      const options = DROPDOWN_DATA[item.name] || [];
      if (options.length === 0) return true;
      return key && value && itemName
        ? item.name === itemName
          ? value === null
          : rowData[item.name] === null
        : rowData[item.name] === null;
    });

    // STEP 2 = CONDITION CHECK BASED ON STEP 1
    // IF SCOPE EXECUTES ONLY IF ISNEWROW === TRUE
    if (Is_All_Value_In_Row_Null) {
      // ASSIGNS THE DROPDOWN OPTIONS ONLY FOR FIRST COLUMN OF THE EDITABLE COLUMNS
      // FOR REST OF THE COLUMNS IT ASSIGNS EMPTY ARRAY
      Edit_Column_Module.map((item, i) => {
        if (i === 0) {
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: DROPDOWN_DATA[item.name],
          }));
        } else {
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: [],
          }));
        }
      });
    } else {
      // LOOP OVER ALL THE EDITABLE COLUMNS AND ASSIGN RESPECTIVE DROPDOWN OPTIONS
      table_header_column_list.map((item) => {
        // EXECUTES IF SCOPE IF is_dependent IS TRUE
        // EXECUTES ELSE SCOPE IF is_dependent IS FALSE
        if (item.is_dependent) {
          const FilteredDropdownOptions = DROPDOWN_DATA[item.name]; //DROPDOWN OPTIONS OF PARTICULAR COLUMN
          const Parent_Column_Name = item.parent_column; // DEPENDENCY COLUMN NAME
          const Parent_Column_Value =
            key && value && itemName
              ? Parent_Column_Name === itemName
                ? value
                : rowData[Parent_Column_Name]
              : rowData[Parent_Column_Name]; //ROWDATA VALUE OF THE DEPENDENCY COLUMN NAME

          // FILTERS CORRECT DROPDOWN OPTIONS BASED ON THE DEPENDENCY COLUMN VALUE
          const filteredFinalOptions =
            Parent_Column_Value !== null
              ? FilteredDropdownOptions.filter(
                  (option) =>
                    option[Parent_Column_Name] === Parent_Column_Value,
                )
              : [];

          let FinalOptions;
          // CHECKS IF FILTERED DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          Edit_Column_Module.map((editItem) => {
            if (editItem.name === item.name && editItem.isArray) {
              FinalOptions =
                filteredFinalOptions.length > 0
                  ? filteredFinalOptions[0][item.name]
                  : [];
            }

            if (editItem.name === item.name && !editItem.isArray) {
              if (sourceData.current_source === "Pos") {
                FinalOptions =
                  filteredFinalOptions.length > 0
                    ? filteredFinalOptions[0][item.name][
                        rowData[editItem.parent_for_dropdown]
                      ]
                    : [];
              } else {
                const Header_Table_Values =
                  sourceData.current_filter_value === "Create new"
                    ? DROPDOWN_DATA[item.name][
                        editData[editItem.parent_for_dropdown].toUpperCase()
                      ]["HEADER_TABLE"][sourceData.current_country]
                    : DROPDOWN_DATA[item.name][
                        editData[editItem.parent_for_dropdown].toUpperCase()
                      ]["HEADER_TABLE"][sourceData.current_country][
                        sourceData.current_ssfFileId
                      ];
                FinalOptions = [
                  ...Header_Table_Values,
                  ...DROPDOWN_DATA[item.name][
                    editData[editItem.parent_for_dropdown].toUpperCase()
                  ]["BRONZE_TABLE"],
                ];
              }
            }
          });

          // SETS STATE WITH DROPDOWN OPTIONS FOR THE RESPECTIVE COLUMNS
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: FinalOptions,
          }));

          // DERIVED VALUES FOR TARGET_COLUMN_NAME
        } else {
          // CHECKS IF COLUMN IN THE CURRENT ITERATION HAS DROPDOWN FIELD
          let result = Edit_Column_Module.find(
            (data) => data.type === "select" && item.name === data.name,
          );

          // IF YES THEN CHECKS IF THE COLUMNS DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          if (result && result.type === "select") {
            let Final_DropDown_Values;
            Edit_Column_Module.map((editItem) => {
              if (editItem.name === item.name && editItem.isArray) {
                Final_DropDown_Values = DROPDOWN_DATA[item.name];
              }
              if (editItem.name === item.name && !editItem.isArray) {
                const BRONZE_TABLE =
                  Object.keys(DROPDOWN_DATA[item.name]["BRONZE_TABLE"]).length >
                    0 && rowData[editItem.parent_for_dropdown]
                    ? DROPDOWN_DATA[item.name]["BRONZE_TABLE"][
                        key === editItem.parent_for_dropdown
                          ? value.toUpperCase()
                          : rowData[editItem.parent_for_dropdown].toUpperCase()
                      ]
                    : [];

                const HEADER_TABLE = rowData[editItem.parent_for_dropdown]
                  ? Object.keys(DROPDOWN_DATA[item.name]["HEADER_TABLE"])
                      .length > 0
                    ? DROPDOWN_DATA[item.name]["HEADER_TABLE"][
                        key === editItem.parent_for_dropdown
                          ? value.toUpperCase()
                          : rowData[editItem.parent_for_dropdown].toUpperCase()
                      ]
                    : []
                  : [];

                Final_DropDown_Values = [
                  ...(Array.isArray(BRONZE_TABLE) && BRONZE_TABLE.length > 0
                    ? BRONZE_TABLE
                    : []),
                  ...(Array.isArray(HEADER_TABLE) && HEADER_TABLE.length > 0
                    ? HEADER_TABLE
                    : []),
                ];
              }
            });

            // SETS STATE WITH DROPDOWN OPTIONS FOR THE RESPECTIVE COLUMNS
            setDropdownOptions((prev) => ({
              ...prev,
              [item.name]: Final_DropDown_Values,
            }));
          }
        }
      });
    }
  };

  useEffect(() => {
    handleDropdownOptions();
  }, []);

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const checkRowDataUpdateStatus = () => {
    let result = false;

    sourceData.current_mapped_data.forEach((item) => {
      if (item.item_Id === wholeRowData.item_Id) {
        // Condition Check for New Data
        if (wholeRowData.isNewData) {
          // Step 1: Check if all editData fields are null
          const allFieldsNull = Edit_Column_Module.every((editItem) => {
            return editData[editItem.name] === null;
          });

          if (allFieldsNull) {
            // Step 2: Check Mandatory column values in rowData are non-null
            const allFieldsNotNull =
              sourceData.data.dropdown.duplicate_validation_attributes.every(
                (key) => {
                  const options = dropdownOptions[key] || [];
                  if (options.length === 0) return true;
                  return rowData[key] !== null;
                },
              );
            result = allFieldsNotNull;
          } else {
            // Step 3: Check if any value has updated
            const anyFieldChanged = Edit_Column_Module.some((key) => {
              const options = dropdownOptions[key.name] || [];
              if (options.length === 0) return false;
              return rowData[key.name] !== wholeRowData.rowData[key.name];
            });
            result = anyFieldChanged;
          }
        } else {
          // Condition Checks for Existing Data
          // Step 1: Check is any values are changed
          const is_Updated = Object.keys(rowData).some(
            (key) => rowData[key] !== wholeRowData.rowData[key],
          );

          if (is_Updated) {
            result = true;
          } else {
            result = false;
          }
        }
      }
    });

    return result;
  };

  const checkIsNoDuplicateData = () => {
    const DUPLICATE_VALIDATION_ATTRIBUTES =
      sourceData.data.dropdown.duplicate_validation_attributes;
    return allRowsData.every((item) => {
      const Existing_Data = item.rowData;
      //If same rowData no need to check ignore it
      if (item.item_Id === wholeRowData.item_Id) return true;
      // If not the same rowData then check the condition
      const result = DUPLICATE_VALIDATION_ATTRIBUTES.every((attribute) => {
        if (Existing_Data[attribute] === null && rowData[attribute] === null)
          return true;
        return Existing_Data[attribute] === rowData[attribute];
      });

      return !result;
    });
  };

  const handleSave = () => {
    setRowHasError(false);

    // CHECKS ANY CHANGES MADE IN RECORD
    const is_Value_Changed = Edit_Column_Module.some((item) => {
      return rowData[item.name] === editData[item.name];
    });
    const isNewDataUpdate = checkRowDataUpdateStatus();
    const Is_No_Duplicate_Data = checkIsNoDuplicateData();

    if (isNewDataUpdate && Is_No_Duplicate_Data) {
      let updatedArray;
      if (wholeRowData.isNewData) {
        const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;

        const isAlreadyEdited = MODIFIED_MAPPED_DATA.some((item) => {
          const updated = item.updated;
          return Object.keys(rowData).every((key) => {
            return updated[key] === editData[key];
          });
        });

        if (isAlreadyEdited) {
          const Updated_Modified_data = MODIFIED_MAPPED_DATA.map((item) => {
            const updated = item.updated;
            const isEditedRowData = Object.keys(rowData).every((key) => {
              return updated[key] === editData[key];
            });

            if (isEditedRowData) {
              return {
                actual: {},
                updated: rowData,
                isNew: true,
                isEdited: false,
              };
            } else {
              return item;
            }
          });

          updatedArray = Updated_Modified_data;
        } else {
          const Updated_Modified_Data = [
            ...MODIFIED_MAPPED_DATA,
            { actual: {}, updated: rowData, isNew: true, isEdited: false },
          ];
          updatedArray = Updated_Modified_Data;
        }
      } else {
        const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;

        const isAlreadyEdited = MODIFIED_MAPPED_DATA.some((item) => {
          const updated = mergeWithObj2Priority(editData, item.updated);
          return Object.keys(rowData).every((key) => {
            return updated[key] === editData[key];
          });
        });

        if (isAlreadyEdited) {
          const Updated_Modified_data = MODIFIED_MAPPED_DATA.map((item) => {
            const updated = mergeWithObj2Priority(editData, item.updated);
            const isEditedRowData = Object.keys(rowData).every((key) => {
              return updated[key] === editData[key];
            });

            if (isEditedRowData) {
              return {
                actual: item.actual,
                updated: { ...item.updated, ...updatedData },
                isNew: false,
                isEdited: true,
              };
            } else {
              return item;
            }
          });

          updatedArray = Updated_Modified_data;
        } else {
          const COMBINED_UPDATED_DATA = mergeWithObj2Priority(
            editData,
            updatedData,
          );
          const Updated_Modified_Data = [
            ...MODIFIED_MAPPED_DATA,
            {
              actual: {
                ...editData,
                COUNTRY_CODE: sourceData.current_country_code,
              },
              updated: {
                ...COMBINED_UPDATED_DATA,
                COUNTRY_CODE: sourceData.current_country_code,
              },
              isNew: false,
              isEdited: true,
            },
          ];
          updatedArray = Updated_Modified_Data;
        }
      }

      //Updating the redux store with final result
      updateSourceInputs("modified_mapped_data", updatedArray);
      props.handleSave(rowData, editData, wholeRowData.item_Id);
    } else {
      setRowHasError(true);
      if (Is_No_Duplicate_Data) {
        if (wholeRowData.isNewData) {
          is_Value_Changed
            ? updateAlert({
                open: true,
                message: "Values cannot be Empty",
                severity: "error",
                closeFlag: true,
              })
            : updateAlert({
                open: true,
                message: "No Value has been changed",
                severity: "error",
                closeFlag: true,
              });
        } else {
          const is_Value_Changed = Edit_Column_Module.every((item) => {
            return editData[item.name] === null;
          });
          is_Value_Changed
            ? updateAlert({
                open: true,
                message: "Values cannot be Empty",
                severity: "error",
                closeFlag: true,
              })
            : updateAlert({
                open: true,
                message: "No Value has been changed",
                severity: "error",
                closeFlag: true,
              });
        }
      } else {
        updateAlert({
          open: true,
          message: "Cannot add duplicate entries",
          severity: "error",
          closeFlag: true,
        });
      }
    }
  };

  const handleRowDelete = () => {
    const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;
    const Updated_Modified_data = MODIFIED_MAPPED_DATA.filter((item) => {
      const updated = item.updated;
      const isEditedRowData = Object.keys(rowData).every((key) => {
        return updated[key] === editData[key];
      });

      return !isEditedRowData && item;
    });

    updateSourceInputs("modified_mapped_data", Updated_Modified_data);
    handleDeleteRow(wholeRowData.item_Id);
  };

  const handleRowValueFix = (key, val) => {
    const updated = { ...rowData, [key]: val };

    const allColumns = DROPDOWN_DATA?.table_header_column_list || [];
    const unwantedColumns = DROPDOWN_DATA?.unwanted_table_column || [];

    const Target_Array = allColumns.filter(
      (item) => !unwantedColumns.includes(item.name),
    );

    const targetIndex = Target_Array.findIndex((item) => item.name === key);
    const Sorted_Columns = Target_Array.slice(targetIndex + 1);

    Sorted_Columns.forEach((item) => {
      updated[item.name] = null;
    });

    setRowData(updated);
  };

  const handleOnSelectChange = (key, val, itemName) => {
    setRowHasError(false);

    setActualData((prev) => ({
      ...prev,
      [key]: rowData[key],
    }));

    setUpdatedRowData((prev) => ({
      ...prev,
      [key]: val,
    }));

    handleDropdownOptions(key, val, itemName);

    if (key === "TARGET_TABLE") {
      isDerivedColumnValue(val);
    }

    handleRowValueFix(key, val);
  };

  const handleOnInputChange = (e, itemName) => {
    setRowHasError(false);
    const ColumnValue = e?.target?.value || "";
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    const updatedData = Object.assign({}, rowData, {
      [itemName]: e.target.value,
    });

    setActualData((prev) => ({
      ...prev,
      [itemName]: rowData[itemName],
    }));

    setUpdatedRowData((prev) => ({
      ...prev,
      [itemName]: e.target.value,
    }));
    setRowData(updatedData);
  };

  const validation = () => {
    return true;
  };

  const handleCancel = () => {
    setRowHasError(!rowHasError);

    const Is_Null =
      sourceData.data.dropdown.duplicate_validation_attributes.some((item) => {
        const options = dropdownOptions[item] || [];
        if (options.length === 0) return false;
        return editData[item] === null;
      });

    const Validation = wholeRowData.isNewData ? !Is_Null : true;

    if (Validation) {
      if (isEditing) {
        props.handleCancel(wholeRowData.item_Id);
      } else {
        props.handleCancel();
      }
    } else {
      setRowHasError(true);
      setErrorMessage("Values cannot be Empty");
    }
  };

  const isDerivedColumnValueCheck = useMemo(() => {
    const DropDown = sourceData?.data?.dropdown;
    const DERIVED_TYPE_DETAILS =
      DROPDOWN_DATA?.derived_target_column_name_details || {};

    const DerivedValues = DropDown?.TARGET_COLUMN_NAME?.find(
      (item) => item.TARGET_TABLE === rowData.TARGET_TABLE,
    );

    const derivedMap = DerivedValues?.derived_target_column_name;

    const ValidationResult =
      derivedMap && typeof derivedMap === "object"
        ? Object.keys(derivedMap).find(
            (key) => key === rowData.TARGET_COLUMN_NAME,
          )
        : null;

    const derivedValue =
      derivedMap && ValidationResult ? derivedMap[ValidationResult] : null;

    const Derived_Type =
      DERIVED_TYPE_DETAILS &&
      typeof DERIVED_TYPE_DETAILS === "object" &&
      derivedValue
        ? Object.keys(DERIVED_TYPE_DETAILS).find((key) => {
            const typeVal = DERIVED_TYPE_DETAILS[key];
            return (
              typeof typeVal === "string" &&
              typeof derivedValue === "string" &&
              typeVal.toLowerCase() === derivedValue.toLowerCase()
            );
          })
        : null;

    const result = ValidationResult
      ? {
          color: derivedValue,
          isDerived: true,
          derived_category: Derived_Type,
        }
      : {
          color: "#212529",
          isDerived: false,
          derived_category: Derived_Type,
        };

    return result;
  }, [rowData]);

  return (
    <TableRow
      key={`editable-${keys}`}
      className={classNames(classes.tableBodyRow, `tableBodyRow_${tableName}`)}
    >
      {/* Content */}
      {Edit_Column_Module.map((item, i) => {
        if (DROPDOWN_DATA?.unwanted_table_column.includes(item.name))
          return null;
        return (
          <StyledTableCell
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
            key={i}
          >
            {item.type === "select" &&
            ((item.name === "VALUE" &&
              rowData.MAPPING_TYPE !== "Calculated" &&
              rowData.MAPPING_TYPE !== "Hardcoded") ||
              item.name !== "VALUE") ? (
              item.isEditable ? (
                <>
                  <CustomSelect
                    errorMessage={errorMessage}
                    classes={{
                      ...selectClasses,
                    }}
                    tableName={tableName}
                    name={item.name}
                    onChange={(key, val) => {
                      handleOnSelectChange(key, val, item.name);
                    }}
                    options={dropdownOptions[item.name] || []}
                    customStyles={customStyles}
                    value={
                      rowData[item.name] === null ||
                      rowData[item.name] === "null"
                        ? ""
                        : rowData[item.name]
                    }
                    error={item.error}
                    selectMessage={item.selectMessage}
                    validation={item.validation}
                    readonly={
                      (dropdownOptions[item.name] || []).length === 0 ||
                      (item.isValidation &&
                        rowData[item.validation] === null) ||
                      rowData[item.validation] === ""
                        ? true
                        : false
                    }
                    showLabel={false}
                    derivedOptions={derivedOptions}
                    sourceData={sourceData}
                  />
                </>
              ) : wholeRowData.isNewData ? (
                <>
                  <CustomSelect
                    errorMessage={errorMessage}
                    classes={{
                      ...selectClasses,
                    }}
                    tableName={tableName}
                    name={item.name}
                    onChange={(key, val) => {
                      handleOnSelectChange(key, val, item.name);
                    }}
                    options={dropdownOptions[item.name] || []}
                    customStyles={customStyles}
                    value={
                      rowData[item.name] === null ||
                      rowData[item.name] === "null"
                        ? ""
                        : rowData[item.name]
                    }
                    error={item.error}
                    selectMessage={item.selectMessage}
                    validation={item.validation}
                    readonly={
                      (dropdownOptions[item.name] || []).length === 0 ||
                      (item.isValidation &&
                        rowData[item.validation] === null) ||
                      rowData[item.validation] === ""
                        ? true
                        : false
                    }
                    showLabel={false}
                    derivedOptions={derivedOptions}
                    sourceData={sourceData}
                  />
                </>
              ) : (
                <>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "40px",
                      padding: "2px 3px",
                      border:
                        rowData[item.name]?.length > 50
                          ? "1px solid #e0e0e0"
                          : "none",
                      overflowX:
                        rowData[item.name]?.length > 50 ? "auto" : "visible",
                      whiteSpace: "nowrap",
                      display: "block",
                      textWrap: "wrap",
                    }}
                    className="scrollable-cell cell-wrapper"
                  >
                    <span>
                      {rowData[item.name]?.length > 0 ? rowData[item.name] : ""}
                    </span>

                    {/* GENESIS, COMMON LABLES */}
                    <span
                      style={{
                        position: "absolute",
                        top: "-2px",
                        marginLeft: "10px",
                      }}
                    >
                      {isDerivedColumnValueCheck &&
                        isDerivedColumnValueCheck.isDerived &&
                        item.name === "TARGET_COLUMN_NAME" && (
                          <span
                            style={{
                              color: `${
                                isDerivedColumnValueCheck &&
                                isDerivedColumnValueCheck.isDerived &&
                                item.name === "TARGET_COLUMN_NAME"
                                  ? isDerivedColumnValueCheck.color
                                  : ""
                              }`,
                              fontSize: "12px",
                              fontWeight: "800",
                              border: `2px solid ${isDerivedColumnValueCheck.color}`,
                              borderRadius: "50%",
                              padding: "0px 4px",
                            }}
                          >
                            {isDerivedColumnValueCheck.derived_category?.[0] ||
                              ""}
                          </span>
                        )}
                    </span>
                  </div>
                </>
              )
            ) : (
              <>
                <Input
                  errorMessage={errorMessage}
                  rowHasError={rowHasError}
                  columnDataArr={(allRowsData || []).map(
                    (obj) => obj.rowData[item.name],
                  )}
                  tableName={tableName}
                  classes={{ ...inputClasses }}
                  type={item.type}
                  name={item.name}
                  onChange={(e) => {
                    handleOnInputChange(e, item.name);
                  }}
                  readonly={
                    (item.isValidation && rowData[item.validation] === null) ||
                    rowData[item.validation] === ""
                      ? true
                      : false
                  }
                  value={rowData[item.name] || ""}
                  item={item.name}
                  childHasError={(bool) => setRowHasError(bool)}
                  error={item.error}
                  validation={validation}
                />
              </>
            )}
          </StyledTableCell>
        );
      })}

      {/* Actions */}
      <StyledTableCell
        className={classNames(
          classes.tableBodyCell,
          `tableBodyCell_${tableName}`,
        )}
      >
        {/* CLOSE */}
        {Is_New_Data_Null && (
          <i
            className="material-icons-outlined "
            style={{ color: "red" }}
            onClick={handleCancel}
          >
            cancel
          </i>
        )}

        {/* SAVE */}
        <i
          className="material-icons-outlined "
          style={{ color: "green" }}
          onClick={handleSave}
        >
          done
        </i>

        {/* DELETE */}
        {wholeRowData.isNewData && (
          <span>
            <i
              className="material-icons-outlined"
              disabled={rowData.isNewData}
              style={{ color: "red" }}
              onClick={handleRowDelete}
            >
              delete
            </i>
          </span>
        )}

        <span style={{ color: "red", fontSize: "12px" }}>
          {!wholeRowData.isValidated && wholeRowData.errorMessage && (
            <Tooltip title={wholeRowData?.errorMessage || ""}>
              <i className="material-icons-outlined">error</i>
            </Tooltip>
          )}
        </span>
      </StyledTableCell>
    </TableRow>
  );
};

const Row = ({
  keys,
  rowData,
  headingRow,
  handleEditRow,
  handleDeleteRow,
  updateSourceInputs,
  classes,
  tableName,
  isAdding,
  isEditing,
  sourceData,
}) => {
  let data = rowData.rowData;

  const handleEditingRow = () => {
    handleEditRow(rowData.item_Id);
  };

  const handleRowDelete = () => {
    const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;
    const Updated_Modified_data = MODIFIED_MAPPED_DATA.filter((item) => {
      const updated = item.updated;
      const isEditedRowData = Object.keys(data).every((key) => {
        return updated[key] === data[key];
      });

      return !isEditedRowData && item;
    });

    updateSourceInputs("modified_mapped_data", Updated_Modified_data);
    handleDeleteRow(rowData.item_Id);
  };

  const isDerivedColumnValue = useMemo(() => {
    const DropDown = sourceData?.data?.dropdown;
    const DERIVED_TYPE_DETAILS = DropDown?.derived_target_column_name_details;

    const DerivedValues = DropDown?.TARGET_COLUMN_NAME?.find(
      (item) => item.TARGET_TABLE === data.TARGET_TABLE,
    );

    const derivedMap = DerivedValues?.derived_target_column_name;

    const ValidationResult =
      derivedMap && typeof derivedMap === "object"
        ? Object.keys(derivedMap).find((key) => key === data.TARGET_COLUMN_NAME)
        : null;

    const derivedValue =
      derivedMap && ValidationResult ? derivedMap[ValidationResult] : null;

    const Derived_Type =
      DERIVED_TYPE_DETAILS &&
      typeof DERIVED_TYPE_DETAILS === "object" &&
      derivedValue
        ? Object.keys(DERIVED_TYPE_DETAILS).find((key) => {
            const typeVal = DERIVED_TYPE_DETAILS[key];
            return (
              typeof typeVal === "string" &&
              typeof derivedValue === "string" &&
              typeVal.toLowerCase() === derivedValue.toLowerCase()
            );
          })
        : null;

    const result = ValidationResult
      ? {
          color: derivedValue,
          isDerived: true,
          derived_category: Derived_Type,
        }
      : {
          color: "#212529",
          isDerived: false,
          derived_category: Derived_Type,
        };

    return result;
  }, [rowData]);

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      className={`${rowData.isValidated ? "table-row" : "table-row-two"}`}
    >
      {headingRow.map(({ label, name }, indexs) =>
        name !== "actions" ? (
          <>
            <StyledTableCell
              className={classNames(
                classes.tableBodyCell,
                `tableBodyCell_${tableName}`,
              )}
              key={`key-${indexs}`}
            >
              <div
                className="scrollable-cell cell-wrapper"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "40px",
                  padding: "2px 3px",
                  border:
                    data[name]?.length > 50 ? "1px solid #e0e0e0" : "none",
                  overflowX: data[name]?.length > 50 ? "auto" : "visible",
                  whiteSpace: "nowrap",
                  display: "block",
                  textWrap: "wrap",
                }}
              >
                <span>
                  {data[name]?.length > 0 && data[name] !== "null"
                    ? data[name]
                    : ""}
                </span>

                {/* GENESIS, COMMON LABLES */}
                <span
                  style={{
                    position: "absolute",
                    top: "-2px",
                    marginLeft: "10px",
                  }}
                >
                  {isDerivedColumnValue &&
                    isDerivedColumnValue.isDerived &&
                    name === "TARGET_COLUMN_NAME" && (
                      <span
                        style={{
                          color: `${
                            isDerivedColumnValue &&
                            isDerivedColumnValue.isDerived &&
                            name === "TARGET_COLUMN_NAME"
                              ? isDerivedColumnValue.color
                              : ""
                          }`,
                          fontSize: "12px",
                          fontWeight: "800",
                          border: `2px solid ${isDerivedColumnValue.color}`,
                          borderRadius: "50%",
                          padding: "0px 4px",
                        }}
                      >
                        {isDerivedColumnValue.derived_category?.[0] || ""}
                      </span>
                    )}
                </span>
              </div>
            </StyledTableCell>
          </>
        ) : (
          // Actions buttons
          <StyledTableCell
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
          >
            <div className="action-icon-container">
              <span style={{ color: "red", fontSize: "12px" }}>
                {!rowData.isValidated && rowData.errorMessage && (
                  <Tooltip title={rowData?.errorMessage || ""}>
                    <i className="material-icons-outlined">error</i>
                  </Tooltip>
                )}
              </span>
              <span>
                {!sourceData.any_row_isEditing ? (
                  <>
                    <i
                      className="material-icons-outlined "
                      disabled={isAdding || isEditing}
                      onClick={handleEditingRow}
                    >
                      edit
                    </i>
                  </>
                ) : (
                  <>
                    <i className="material-icons-outlined ">edit</i>
                  </>
                )}
              </span>
              {rowData.isNewData && (
                <span>
                  <i
                    className="material-icons-outlined"
                    disabled={rowData.isNewData}
                    style={{ color: "red" }}
                    onClick={handleRowDelete}
                  >
                    delete
                  </i>
                </span>
              )}
            </div>
          </StyledTableCell>
        ),
      )}
    </TableRow>
  );
};

const EditableTable = (props) => {
  const { classes = {}, tableName, source_data = {}, ...rest } = props;
  const [allRowsData, setAllRowsData] = useState(props.defaultData || []);
  const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage || 5);
  const [page, setPage] = useState(props.page || 0);
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [paginatedRows, setPaginatedRows] = useState(
    allRowsData.slice(0, rowsPerPage),
  );
  //   Multi Filter States
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState(
    props.source_data.appliedFilters || [],
  );
  const [tableHeadColumns, setTableHeadColumns] = useState([
    ...(
      props?.source_data?.data?.dropdown?.table_header_column_list ?? []
    ).filter(
      (item) =>
        !props?.source_data?.data?.dropdown?.unwanted_table_column.includes(
          item.name,
        ),
    ),
    { label: "Actions", name: "actions" },
  ]);
  const [selectedColumns, setSelectedColumns] = useState(
    props?.source_data?.data?.dropdown?.edit_model_column_list.filter(
      (item) => {
        return tableHeadColumns.some((col) => {
          return item.name === "UPC"
            ? col.label === item.name
            : col.name === item.name;
        });
      },
    ) || [],
  );

  const Total_Errors = useMemo(() => {
    return source_data.current_mapped_data.filter((item) => !item.isValidated)
      .length;
  }, [source_data.current_mapped_data]);

  const handlePaginatedRows = (newPage, AllRowsData) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = AllRowsData
      ? AllRowsData.slice(start, end)
      : allRowsData.slice(start, end);
    return currentPageRows;
  };

  const handleSave = (updatedRowData, oldRowData, editingIndex) => {
    props.setIsSearchFilterLoading(false);
    const updated = props.source_data.current_mapped_data.map((item) =>
      item.item_Id === editingIndex
        ? {
            ...item,
            isEdited: true,
            isEditing: false,
            isValidated: true,
            rowData: updatedRowData,
          }
        : item,
    );
    props.updateSourceInputs("current_mapped_data", updated);
    props.updateSourceInputs("any_row_isEditing", false);
    props.updateSourceInputs("isNewDataInserted", false);

    const Paginated_Rows = handlePaginatedRows(page, updated);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(updated);
    setEditingIndex(null);
    setIsEditing(false);
    props.updateAlert({
      open: true,
      message: "Mapping changes saved successfully",
      severity: "info",
      closeFlag: true,
    });
  };

  const handleCancel = (index) => {
    props.setIsSearchFilterLoading(false);
    const updated = props.source_data.current_mapped_data.map((item) =>
      item.item_Id === index ? { ...item, isEditing: false } : item,
    );
    const updated_Filtered_Rows = props.source_data.filtered_Rows.map((item) =>
      item.item_Id === index ? { ...item, isEditing: false } : item,
    );

    props.updateSourceInputs("current_mapped_data", updated);
    props.updateSourceInputs("filtered_Rows", updated_Filtered_Rows);
    props.updateSourceInputs("any_row_isEditing", false);

    const Paginated_Rows = handlePaginatedRows(page, updated);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(updated);
    setEditingIndex(null);
    setIsEditing(false);
  };

  const handleEditRow = (index) => {
    props.setIsSearchFilterLoading(true);
    const updated = props.source_data.current_mapped_data.map((item) =>
      item.item_Id === index ? { ...item, isEditing: true } : item,
    );
    const updated_Filtered_Rows = props.source_data.filtered_Rows.map((item) =>
      item.item_Id === index ? { ...item, isEditing: true } : item,
    );
    props.updateSourceInputs("current_mapped_data", updated);
    props.updateSourceInputs("filtered_Rows", updated_Filtered_Rows);
    props.updateSourceInputs("any_row_isEditing", true);

    setAllRowsData(updated);
    const Paginated_Rows = handlePaginatedRows(page, updated);
    setPaginatedRows(Paginated_Rows);
    setEditingIndex(index);
    setIsEditing(true);
  };

  const handleDeleteRow = (index) => {
    const updated = props.source_data.current_mapped_data.filter(
      (item) => item.item_Id !== index,
    );
    const reindexed = updated.map((item, idx) => ({ ...item, item_Id: idx }));
    props.updateSourceInputs("current_mapped_data", reindexed);
    props.updateSourceInputs("any_row_isEditing", false);
    props.updateSourceInputs("isNewDataInserted", false);

    const Paginated_Rows = handlePaginatedRows(page, reindexed);
    setPaginatedRows(Paginated_Rows);
    props.updateAlert({
      open: true,
      message: "RowData has been Deleted successfully",
      severity: "info",
      closeFlag: true,
    });
  };

  const handleSearchValue = (val) => {
    setPage(0);
    setRowsPerPage(10);
    if (!val || val.length === 0) {
      setAllRowsData(props.source_data.current_mapped_data);
      setSearchValue("");
      props.updateSourceInputs("searchValue", "");
      if (
        props.source_data.appliedFilters &&
        props.source_data.appliedFilters.length > 0
      ) {
        handleApplyFilter(
          appliedFilters.Column,
          appliedFilters.Values,
          0,
          props.source_data.appliedFilters,
        );
      } else {
        const Paginated_Rows = handlePaginatedRows(
          0,
          props.source_data.current_mapped_data,
        );
        setPaginatedRows(Paginated_Rows);
      }
    } else {
      let filtered;
      if (
        props.source_data.filtered_Rows &&
        props.source_data.filtered_Rows.length > 0
      ) {
        filtered = props.source_data.filtered_Rows.filter((item) => {
          return props.source_data.data.dropdown.search_filter_details.search_filter_attributes.some(
            (attribute) => {
              return (item?.rowData[attribute.name] || "")
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      } else {
        filtered = props.source_data.current_mapped_data.filter((item) => {
          return props.source_data.data.dropdown.search_filter_details.search_filter_attributes.some(
            (attribute) => {
              return (item?.rowData[attribute.name] || "")
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      }
      setSearchValue(val);
      props.updateSourceInputs("searchValue", val);
      setAllRowsData(filtered);
      const Paginated_Rows = handlePaginatedRows(0, filtered);
      setPaginatedRows(Paginated_Rows);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage);
    setPaginatedRows(Paginated_Rows);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = allRowsData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  const handleOpenColumnFilter = (e) => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot Filter columns while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }
    setAnchorE2(e.currentTarget);
  };

  const handleDownload = () => {
    if (isEditing) {
      props.updateAlert({
        open: true,
        message:
          "Cannot download while editing. Please try after editing the record.",
        severity: "info",
        closeFlag: true,
      });
      return;
    }

    // INITIALIZING TABLE DATA
    const MetaData_Filter =
      props?.source_data?.data?.dropdown?.metadata_filter || [];
    const tableData =
      props?.source_data?.current_mapped_data.map((item) => ({
        ...item.rowData,
      })) || [];

    if (!tableData || !tableData.length > 0) {
      props.updateAlert({
        open: true,
        message: "No sample data available to download.",
        severity: "Failed",
        closeFlag: true,
      });
      return;
    }

    let order_check_data = [
      ...(MetaData_Filter || []),
      ...(props?.source_data?.data?.dropdown?.table_header_column_list.map(
        (item) => item.name,
      ) || []),
    ];

    if (props.source_data?.current_source?.toLowerCase() === "nielsen") {
      order_check_data = [
        ...order_check_data.filter((item) => item !== "COUNTRY_CODE"),
        "COUNTRY_CODE",
      ];
    }

    const Download_Data = tableData.map((item) => {
      const { CREATED_AT, CREATED_BY, UPDATED_AT, UPDATED_BY, ...rest } = item;
      // filter arrayTwo keeping order of arrayOne
      let result = {};
      order_check_data.forEach((key) => {
        result = {
          ...result,
          [key]: rest[key] || "",
        };
      });
      return result;
    });

    const sampleData = [...Download_Data];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");
    XLSX.writeFile(
      workbook,
      `${Download_Data?.[0]?.[MetaData_Filter?.[1]] || "Table Data"}_${
        props?.source_data?.current_source || ""
      }.xlsx`,
    );
  };

  const handleApplyFilter = (column, values, currentPage, filters) => {
    // STORES AND UPDATE FILTERS
    const newFilters =
      typeof currentPage === "number"
        ? filters
          ? [...filters]
          : [...appliedFilters]
        : [...appliedFilters, { Column: column, Values: values }];
    setAppliedFilters(newFilters);
    props.updateSourceInputs("appliedFilters", newFilters);

    const ALL_ROWS = props.source_data.current_mapped_data || [];

    // CHECK ROWS THAT MATCHES THE FILTERS
    let filtered;
    if (newFilters.length > 0) {
      const FILTERED_ROWS = props.source_data.filtered_Rows;
      const CURRENT_FILTER = [{ Column: column, Values: values }];
      if (FILTERED_ROWS && FILTERED_ROWS.length > 0) {
        if (filters && filters.length > 0) {
          let FILTERED_ROWS = ALL_ROWS;
          filters.forEach((filter) => {
            FILTERED_ROWS = FILTERED_ROWS.filter((row) => {
              const cellValue = row?.rowData?.[filter.Column.name];
              return filter.Values.includes(cellValue);
            });
          });
          filtered = FILTERED_ROWS;
        } else {
          filtered = FILTERED_ROWS.filter((row) =>
            CURRENT_FILTER.some((filter) =>
              filter.Values.includes(row.rowData[filter.Column.name]),
            ),
          );
        }
      } else {
        filtered = ALL_ROWS.filter((row) =>
          CURRENT_FILTER.some((filter) =>
            filter.Values.includes(row.rowData[filter.Column.name]),
          ),
        );
      }
    } else {
      filtered = ALL_ROWS;
    }

    // UPDATES THE FILTERED ROWS
    props.updateSourceInputs("filtered_Rows", filtered);

    // UPDATES THE FILTERED ROWS WITH CURRENT PAGINATION
    const Paginated_Rows = handlePaginatedRows(
      typeof currentPage === "number" ? currentPage : 0,
      filtered,
    );
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(filtered);
  };

  const handleRemoveFilter = (filter) => {
    // REMOVES FILTER FROM FILTER LIST
    const SortedFilters = appliedFilters.filter((existingFilter) => {
      const isSame_Column = existingFilter.Column.label === filter.Column.label;

      const valuesA = existingFilter.Values;
      const valuesB = filter.Values;

      const isSame_Values =
        valuesA.length === valuesB.length &&
        valuesA.every((val) => valuesB.includes(val));

      const result = isSame_Column && isSame_Values ? false : true;

      return result;
    });

    setAppliedFilters(SortedFilters);
    props.updateSourceInputs("appliedFilters", SortedFilters);

    const ALL_ROWS = props.source_data.current_mapped_data || [];

    // CHECK ROWS THAT MATCHES THE FILTERS
    let FILTERED_ROWS;
    if (SortedFilters.length > 0) {
      SortedFilters.forEach((filter) => {
        FILTERED_ROWS = ALL_ROWS.filter((row) => {
          const cellValue = row?.rowData?.[filter.Column.name];
          return filter.Values.includes(cellValue);
        });
      });
    } else {
      FILTERED_ROWS = ALL_ROWS;
    }

    // UPDATES THE FILTERED ROWS
    props.updateSourceInputs("filtered_Rows", FILTERED_ROWS);

    // UPDATES THE FILTERED ROWS WITH CURRENT PAGINATION
    const Paginated_Rows = handlePaginatedRows(0, FILTERED_ROWS);
    setPaginatedRows(Paginated_Rows);
    setAllRowsData(FILTERED_ROWS);
  };

  const handleNullCheck = () => {
    const dropdown = props.source_data?.data?.dropdown;
    const currentMappedData = props.source_data?.current_mapped_data;

    return (
      dropdown?.table_header_column_list?.length === 0 &&
      dropdown?.duplicate_validation_attributes?.length === 0 &&
      dropdown?.edit_model_column_list?.length === 0 &&
      Array.isArray(currentMappedData) &&
      currentMappedData.length === 0
    );
  };

  const handleColumnFilter = (columns) => {
    const editModelColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];

    const Mandatory_Columns =
      props?.source_data?.data?.dropdown?.column_filter_details
        ?.mandatory_column_list || [];

    // SORT EDITABLE COLUMNS
    const Sorted_Columns = [
      ...editModelColumns.filter((item) =>
        Mandatory_Columns?.some((col) => col.name === item.name),
      ),
      ...editModelColumns.filter((item) =>
        columns.some((col) =>
          item.name === "UPC"
            ? col.label === item.name
            : col.name === item.name,
        ),
      ),
    ];

    // SORT TABLE HEADER COLUMNS
    const Sorted_Table_Head_Columns = [
      ...Mandatory_Columns,
      ...columns,
      { label: "Actions", name: "actions" },
    ];

    const Sorted_Columns_Final = [...Sorted_Columns].sort(
      (a, b) =>
        Sorted_Table_Head_Columns.findIndex((col) => col.name === a.name) -
        Sorted_Table_Head_Columns.findIndex((col) => col.name === b.name),
    );

    // SET STATES
    setTableHeadColumns(Sorted_Table_Head_Columns);
    setSelectedColumns(Sorted_Columns_Final);
    props.updateSourceInputs("current_columns", columns);
  };

  const handleColumnChange = () => {
    const editModelColumns =
      props?.source_data?.data?.dropdown?.edit_model_column_list || [];
    const currentColumns = props?.source_data?.current_columns || [];

    if (!Array.isArray(editModelColumns) || !Array.isArray(currentColumns)) {
      return;
    }

    if (editModelColumns.length === 0 || currentColumns.length === 0) {
      return;
    }

    const Mandatory_Columns =
      props?.source_data?.data?.dropdown?.column_filter_details
        ?.mandatory_column_list || [];

    // SORT EDITABLE COLUMNS
    const Sorted_Columns = [
      ...editModelColumns.filter((item) =>
        Mandatory_Columns?.some((col) => col.name === item.name),
      ),
      ...editModelColumns.filter((item) =>
        currentColumns.some((col) =>
          item.name === "UPC"
            ? col.label === item.name
            : col.name === item.name,
        ),
      ),
    ];

    // SORT TABLE HEADER COLUMNS
    const Sorted_Table_Head_Columns = [
      ...Mandatory_Columns,
      ...currentColumns,
      { label: "Actions", name: "actions" },
    ];

    const Sorted_Columns_Final = [...Sorted_Columns].sort(
      (a, b) =>
        Sorted_Table_Head_Columns.findIndex((col) => col.name === a.name) -
        Sorted_Table_Head_Columns.findIndex((col) => col.name === b.name),
    );

    // SET STATES
    setTableHeadColumns(Sorted_Table_Head_Columns);
    setSelectedColumns(Sorted_Columns_Final);
  };

  const handleParsedFile = (jsonData) => {
    // Perform your validations, set state, etc.
  };

  useEffect(() => {
    handleColumnChange();
  }, [props.source_data.current_columns]);

  useEffect(() => {
    setAllRowsData(props.defaultData || []);
    let Paginated_Rows;
    if (props.source_data.isNewDataInserted) {
      Paginated_Rows = handlePaginatedRows(0, props.defaultData);
      setPage(0);
      setRowsPerPage(10);
    } else {
      Paginated_Rows = handlePaginatedRows(page, props.defaultData);
    }

    setPaginatedRows(Paginated_Rows);
  }, [props.defaultData]);

  // Apply Filters
  useEffect(() => {
    // Reapply all filters
    if (
      props.source_data.appliedFilters &&
      props.source_data.appliedFilters.length > 0
    ) {
      handleApplyFilter(
        appliedFilters.Column,
        appliedFilters.Values,
        page,
        props.source_data.appliedFilters,
      );
    }

    if (
      props.source_data.searchValue &&
      props.source_data.searchValue.length > 0
    ) {
      handleSearchValue(props.source_data.searchValue);
    }
  }, [props.source_data.current_mapped_data]);

  // Apply Search Filter
  useEffect(() => {
    // Apply search
    const searchValue = props.source_data.searchValue;
    const hasSearchValue =
      typeof searchValue === "string" && searchValue.length > 0;
    const hasFilteredRows =
      Array.isArray(props.source_data.filtered_Rows) &&
      props.source_data.filtered_Rows.length > 0;

    if (hasSearchValue && hasFilteredRows) {
      const Filtered_Rows = props.source_data.filtered_Rows;
      const filtered = Filtered_Rows.filter((item) =>
        (item?.rowData?.MAPPING_TYPE || "")
          .toLowerCase()
          .includes(searchValue.toLowerCase()),
      );

      const Paginated_Rows = handlePaginatedRows(page, filtered);
      setPaginatedRows(Paginated_Rows);
      setAllRowsData(filtered);
    }
  }, [props.source_data.filtered_Rows]);

  useEffect(() => {
    if (
      props.source_data.appliedFilters.length === 0 &&
      appliedFilters.length > 0
    ) {
      setAppliedFilters([]);
    }
  }, [props.source_data.appliedFilters]);

  if (handleNullCheck()) {
    return <Loader />;
  }

  const sourceDropdownData = props.sourceDropdownData || {};

  const fieldsArr1 = [
    {
      label: "Mapping Type",
      name: "MAPPING_TYPE",
      type: "select",
      validation: (e) => e.target.value.length <= 1,
      error: "error",
    },
    {
      label: "Target Table",
      name: "TARGET_TABLE",
      type: "select",
      validation: (e) => e.target.value.length <= 1,
      error: "error",
    },
    {
      label: "Target Column Name",
      name: "TARGET_COLUMN_NAME",
      type: "select",
      options: sourceDropdownData.NIELSEN_SUB_CATEGORY || [],
      validation: (e) => e.target.value.length <= 1,
      error: "error",
    },
    {
      label: "Value",
      name: "Value",
      type: "select",
      options: sourceDropdownData.NIELSEN_SEGMENT || [],
      validation: (e) => e.target.value.length <= 5,
      error: "error",
    },
    {
      label: "Enrichment Preference",
      name: "ENRICHMENT_PREFERENCE",
      type: "select",
      options: sourceDropdownData.NIELSEN_SUB_SEGMENT || [],
      validation: (e) => e.target.value.length <= 5,
      error: "error",
    },
  ];

  const TableHeadData_Sorted =
    props?.source_data?.data?.dropdown?.table_header_column_list?.filter(
      (item) => {
        return (
          item.name !== "ENRICHMENT_PREFERENCE" &&
          item.name !== "Comments" &&
          item.name !== "SOURCE_TABLE"
        );
      },
    ) || [];

  const TABLEHEAD_DATA = [
    ...TableHeadData_Sorted,
    { label: "Actions", name: "actions" },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* SEARCH FILTER */}
        {props?.source_data?.data?.dropdown?.search_filter_details
          ?.is_search_filter && (
          <SearchBar
            handleSearchValue={handleSearchValue}
            placeholder={`Search with ${
              (
                props?.source_data?.data?.dropdown?.search_filter_details
                  ?.search_filter_attributes || []
              )
                .map((attr) => attr?.label)
                .filter(Boolean)
                .join(", ") || "..."
            }`}
            value={props?.source_data?.searchValue || ""}
          />
        )}

        {/* ERROR LABEL */}
        {Total_Errors > 0 && (
          <div
            style={{
              backgroundColor: "rgba(255, 0, 0, 0.2)",
              padding: "2px 10px",
              paddingRight: "10px",
              paddingLeft: "5px",
              borderRadius: "30px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span style={{ color: "red", fontSize: "0px" }}>
              <i className="material-icons-outlined">error</i>
            </span>
            <span
              style={{
                color: "red",
                fontWeight: "600",
                fontSize: "12px",
                marginTop: "3px",
              }}
            >
              Total errors: {Total_Errors}
            </span>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* MULTI FILTER */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* Filter Pill */}
            <div className="scroll-bar">
              {appliedFilters.map((filter) => {
                return (
                  <div className="pill">
                    <span
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {filter.Column.label}
                    </span>
                    <span
                      style={{
                        margin: "0 6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      is one of
                    </span>
                    <span
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100px",
                      }}
                    >
                      {filter.Values.map((v) =>
                        v === null
                          ? "Null"
                          : v === undefined
                            ? "Undefined"
                            : String(v),
                      ).join(", ")}
                    </span>
                    <button
                      onClick={() => handleRemoveFilter(filter)}
                      style={{
                        marginLeft: "8px",
                        color: "#666",
                        fontSize: "18px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#e00")}
                      onMouseLeave={(e) => (e.target.style.color = "#666")}
                    >
                      &times;
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Filter Button */}
            <div>
              {props?.source_data?.data?.dropdown &&
                props?.source_data?.data?.dropdown?.filter_details
                  ?.is_filterable && (
                  <button
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    className="filter-button"
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{
                        fontVariationSettings: "'wght' 200",
                        fontSize: "20px",
                      }}
                    >
                      {props?.source_data?.data?.dropdown?.filter_details
                        ?.button_icon || "filter_alt"}
                    </span>
                    <span>
                      {props?.source_data?.data?.dropdown?.filter_details
                        ?.button_text || "Filter"}
                    </span>
                  </button>
                )}
            </div>

            {/* Filter POPOVER */}
            {props?.source_data?.data?.dropdown?.filter_details && (
              <MultiFilter
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                columns={
                  props.source_data.data.dropdown.filter_details.filter_details
                }
                values={
                  props.source_data.filtered_Rows &&
                  props.source_data.filtered_Rows.length > 0
                    ? props.source_data.filtered_Rows
                    : props.source_data.current_mapped_data || []
                }
                onApplyFilter={handleApplyFilter}
              />
            )}
          </div>

          {/* COLUMN FILTER */}
          {props?.source_data?.data?.dropdown?.column_filter_details &&
            props?.source_data?.data?.dropdown?.column_filter_details
              ?.is_column_filterable && (
              <div>
                {/* BUTTON */}
                <button
                  onClick={handleOpenColumnFilter}
                  className="filter-button"
                >
                  <span
                    className="material-symbols-outlined"
                    style={{
                      fontVariationSettings: "'wght' 200",
                      fontSize: "20px",
                    }}
                  >
                    {props?.source_data?.data?.dropdown?.column_filter_details
                      ?.button_icon || "table_edit"}
                  </span>
                  <span>
                    {props?.source_data?.data?.dropdown?.column_filter_details
                      ?.button_text || "Columns"}
                  </span>
                </button>

                {/* POPOVER */}
                <ColumnFilter
                  anchorE2={anchorE2}
                  setAnchorE2={setAnchorE2}
                  totalColumns={
                    props?.source_data?.data?.dropdown?.column_filter_details
                      ?.filterable_columns || []
                  }
                  tableHeaderColumns={tableHeadColumns.filter(
                    (col) => col.name !== "actions",
                  )}
                  standardHeaderColumns={
                    props?.source_data?.data?.dropdown?.table_header_column_list
                  }
                  onApplyFilter={handleColumnFilter}
                  updateAlert={props.updateAlert}
                  sourceData={props?.source_data}
                  useCase={"SilverTemplateMapping"}
                />
              </div>
            )}

          {/* DOWNLOAD BUTTON */}
          {props?.source_data?.data?.dropdown?.downloable_details &&
            props?.source_data?.data?.dropdown?.downloable_details
              ?.is_downloadble && (
              <button onClick={handleDownload} className="filter-button">
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontVariationSettings: "'wght' 200",
                    fontSize: "20px",
                  }}
                >
                  {props?.source_data?.data?.dropdown?.downloable_details
                    ?.button_icon || ""}
                </span>
                <span>
                  {props?.source_data?.data?.dropdown?.downloable_details
                    ?.button_text || "Download"}
                </span>
              </button>
            )}

          {/* PowerBI Button */}
          {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS &&
            props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
              ?.IS_POWER_BI && (
              <a
                href={
                  props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.POWER_BI_URL || "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="powerbi-button"
              >
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontVariationSettings: "'wght' 200",
                    fontSize: "20px",
                  }}
                >
                  {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.button_icon || ""}
                </span>
                <span>
                  {props?.source_data?.data?.dropdown?.POWER_BI_DETAILS
                    ?.button_text || "PowerBI Dashboard"}
                </span>
              </a>
            )}
        </div>
      </div>

      <TableContainer className={Tablestyles.budget_tb2}>
        <Table
          stickyHeader
          className={classNames(classes.table, `table_${tableName}`)}
        >
          <TableHead className="table-heading">
            <TableRow
              className={classNames(
                classes.tableHeadRow,
                `tableHeadRow_${tableName}`,
              )}
            >
              {tableHeadColumns.map(({ label, name }, i) => (
                <StyledTableCell
                  key={i}
                  className={classNames(
                    classes.tableHeadCell,
                    classes[`tableHeadCell${name}`],
                    `tableHeadCell_${tableName} tableHeadCell_${name}`,
                  )}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginLeft: "3px",
                    }}
                  >
                    <span>{label}</span>
                    {/* {(name === "MAPPING_TYPE" || name === "TARGET_TABLE") && (
                      <FilterPopover
                        handleMultiFilter={handleMultiFilter}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        attributeName={name}
                        options={props.source_data.data.dropdown[name]}
                      />
                    )} */}
                  </div>
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody
            className={classNames(classes.tableBody, `tableBody_${tableName}`)}
          >
            {paginatedRows.map((rowData, i) =>
              rowData.isEditing ? (
                <EditableRow
                  key={i}
                  updateAlert={props.updateAlert}
                  tableName={props.tableName}
                  isEditing={rowData.isEditing}
                  customStyles={{}}
                  wholeRowData={rowData}
                  editingIndex={editingIndex}
                  handleDeleteRow={handleDeleteRow}
                  brand_data={props.brand_data}
                  updateSourceInputs={props.updateSourceInputs}
                  sourceData={props.source_data}
                  selectClasses={classes}
                  inputClasses={classes}
                  classes={classes}
                  allRowsData={allRowsData}
                  editData={rowData.rowData}
                  handleSave={handleSave}
                  handleCancel={handleCancel}
                  fieldsArr={fieldsArr1}
                />
              ) : (
                <Row
                  key={i}
                  tableName={props.tableName}
                  classes={classes}
                  updateSourceInputs={props.updateSourceInputs}
                  sourceData={props.source_data}
                  headingRow={tableHeadColumns}
                  isAdding={isAdding}
                  isEditing={isEditing}
                  handleEditRow={handleEditRow}
                  handleDeleteRow={handleDeleteRow}
                  rowData={rowData}
                />
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {allRowsData.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={allRowsData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      {allRowsData.length === 0 && (
        <div style={{ textAlign: "center" }}>No Data Found.</div>
      )}
    </>
  );
};

EditableTable.propTypes = {
  brand_data: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};

// export default EditableTable;
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditableTable),
);
